export default __webpack_public_path__ + "static/media/geotech.f4654ec9.jpg";